/**
 * Cliente stub — POST /api/v1/voice-notes/ingest (TJS Gateway / Controller).
 * Fase 1: fire-and-forget; 404 / sin sesión → skipped sin lanzar a UI.
 */
import { getControllerUrl, loadControllerSession } from '../services/controllerAuth'
import { VOICE_INGEST_PATH } from './types'

const FEATURE_FLAG_KEY = 'udv.voiceNotes.ingestEnabled'

/**
 * @returns {boolean}
 */
export function isVoiceIngestEnabled() {
  try {
    const v = window.localStorage.getItem(FEATURE_FLAG_KEY)
    if (v === '0' || v === 'false') return false
    if (v === '1' || v === 'true') return true
  } catch (e) {
    /* ignore */
  }
  // Por defecto: intentar si hay sesión Controller (stub silencioso si 404)
  return true
}

/**
 * @param {import('./types').IngestRequest} req
 * @returns {Promise<import('./types').IngestResponse>}
 */
export async function ingestVoiceNote(req) {
  if (!isVoiceIngestEnabled()) {
    return { status: 'skipped', message: 'ingest deshabilitado' }
  }
  if (!req || !req.audio) {
    return { status: 'skipped', message: 'sin audio' }
  }

  const session = loadControllerSession()
  const baseUrl = (session && session.serverUrl) || getControllerUrl()
  const token = session && session.token
  if (!token) {
    return { status: 'skipped', message: 'sin sesión Controller' }
  }

  const url = `${String(baseUrl).replace(/\/+$/, '')}${VOICE_INGEST_PATH}`
  const form = new FormData()
  const audioFile =
    req.audio instanceof File
      ? req.audio
      : new File([req.audio], 'audio.mp3', { type: 'audio/mp3' })
  form.append('audio', audioFile, 'audio.mp3')
  form.append(
    'alignment',
    new Blob([JSON.stringify(req.alignment || { events: [] })], {
      type: 'application/json',
    }),
    'alignment.json'
  )
  form.append(
    'metadata',
    new Blob([JSON.stringify(req.metadata || {})], { type: 'application/json' }),
    'metadata.json'
  )
  if (req.transcript) {
    form.append(
      'transcript',
      new Blob([JSON.stringify(req.transcript)], { type: 'application/json' }),
      'transcript.json'
    )
  }

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: form,
    })
    if (res.status === 404 || res.status === 501) {
      return { status: 'skipped', message: `endpoint ${res.status}` }
    }
    if (res.status === 202 || res.ok) {
      let body = null
      try {
        body = await res.json()
      } catch (e) {
        body = null
      }
      return {
        status: 'accepted',
        sample_id_hash: body && body.sample_id_hash,
        message: body && body.message,
      }
    }
    return {
      status: 'error',
      message: `HTTP ${res.status}`,
    }
  } catch (e) {
    return {
      status: 'error',
      message: (e && e.message) || String(e),
    }
  }
}

export default ingestVoiceNote
